export default __webpack_public_path__ + "images/0a4bdf317cae1d45c641e40a4e9115a0.svg";